// extracted by mini-css-extract-plugin
export var carrierIcon = "_vx-0";
export var carrierLogo = "_vx-1";
export var detailsSection = "_vx-2";